import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { Loader, Title, TravelVisaTeaser } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const visaCopy = copy.userTravelVisa;

export const TravelVisas: FC = () => {
  const { travelVisas } = useFullUserProfileContext();

  const { fetchingTravelVisas } = useFetchingUserDocuments();

  if (fetchingTravelVisas) return <Loader />;
  if (!travelVisas?.length) return null;

  return (
    <Spacer size="m">
      <Title title={visaCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {travelVisas?.map(visa => (
          <TravelVisaTeaser key={visa.id} {...visa} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
